
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/northern-ireland-house-prices",
      function () {
        return require("private-next-pages/northern-ireland-house-prices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/northern-ireland-house-prices"])
      });
    }
  